import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';


@Component({
  selector: 'app-multi-market',
  templateUrl: './multi-market.component.html',
  styleUrls: ['./multi-market.component.css']
})
export class MultiMarketComponent extends BaseClass<any> implements OnInit {

  @ViewChild('betSlipModal', { static: false }) betSlipModal?: ModalDirective;

  public data: any;
  public token: any = '';
  public fancyRun: any;
  public baseUrl: any = '';
  public marketsReq: any[] = [];
  public marketIds: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public oddsLisDisNew: any = {};
  public expoLisDis: any = {};
  public nextExpoList: any = {};
  public newOddsEnable: boolean = false;
  public allFancy: any[] = [];
  public marketData: any;
  betSlipData: any = {};
  modalRef?: BsModalRef;
  public isLoad: boolean = false;
  isCollapsed = {
    match_odds: [] as any,
    book_makers: [] as any,
    fancy: [] as any,
    line: false,
    markets: [] as any,
    tv: {
      desktop: true,
      mobile: false
    },
    scoreTable: true
  }
  multiMarketIds: any[] = [];
  scrolled: boolean = false;

  constructor(public service: WebserviceService,
    public _common: CommonService,
    public _message: MessageService,
    public router: Router,
    private modalService: BsModalService
  ) {
    super();
    //emit value in sequence every given second\
    const sub1 = interval(this.env.pollers.oddsData).subscribe(val => {
      if (this.baseUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.marketData, false);
        } else {
          this.getOdds(this.marketsReq, false);
        }
      }
    });
    this.subs.push(sub1);
  }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  @HostListener("window:scroll", [])
    onWindowScroll() {
        this.scrolled = window.scrollY > 100;
    }

  getData() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = Object.entries(res.data.fav_markets).map(([key, value]) => (value));
          this.marketsReq = this.createMarketIdList(this.data) as any;
          this.marketIds = this.createMarketIds(this.data) as any;
          this.token = res?.data?.token;
          this.multiMarketIds = JSON.parse(res?.data?.active_markets);
          this.baseUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;

          this.data.forEach((element: any, i: any) => {
            let fancyItems: any[] = element.filter((item: any) => item.market_id[0] == '9');
            let dt = element.filter((item: any) => item.market_id[0] != '9');
            if (fancyItems.length > 0) {
              let fis: any[] = [];
              fancyItems.forEach(element => {
                element.fancy['sort_priority'] = 0;
                fis.push(element.fancy);
              });
              dt.push({ market_id: fancyItems[0]?.market_id, event_type_id: fancyItems[0]?.event_type_id, market_type_id: 'FANCY', event_id: fancyItems[0]?.event_id, allFancy: [0], name: fancyItems[0]?.event?.name, sort: 3, data: fis })
            }

            this.data[i] = dt
          });



          this.data.forEach((element: any) => {
            let mdt = element.filter((item: any) => item.market_id[0] == '1')
            mdt.forEach((mEle: any) => {
              mEle['sort'] = mEle?.market_type_id == 'MATCH_ODDS' ? 1 : 4
            });
            let bdt = element.filter((item: any) => item.market_id[0] == '8')
            bdt.forEach((bEle: any) => {
              bEle['sort'] = 2
            });

            this.isCollapsed.match_odds = (this.isCollapsed.match_odds.length == 0) ? Array(mdt.length).fill(false) as any : this.isCollapsed.match_odds;
            this.isCollapsed.book_makers = (this.isCollapsed.book_makers.length == 0) ? Array(bdt.length).fill(false) as any : this.isCollapsed.book_makers;
            if (element.filter((item: any) => item.market_id[0] != '9').length > 0)
              this.isCollapsed.fancy.push(false)
          });



          this.data.forEach((element: any) => {
            element.sort((a: any, b: any) => (a.sort > b.sort) ? 1 : -1);
          });

          // this.data.sort((a:any, b:any) => (a.sort > b.sort) ? 1 : -1);
          if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.marketData = res?.data;
            this.getOddsNew(this.marketsReq, res.data, true);
          } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, true);
          }
          this.getExposure(this.marketsReq, this.data);
          //console.log(this.data);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getOdds(req: any, isDetail: boolean) {
    this.getServices().Post(`${this.baseUrl + this.api.odds}`, req).subscribe(
      (res) => {

        res = this.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        let oods = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.setOdds(oods);
        this.isLoad = false;

        // this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));
        // this.betSlipData['oddsLisDis'] = this.oddsLisDis;

        // if (isDetail) {
        //   this.isLoad = false;
        // }
      },
      (err) => {
        console.log(err);
      });
  }

  getOddsNew(req: any, resData: any, isDetail: boolean) {
    this.getServices().Post(`${this.baseUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.setOdds(this.oddsLisDisNew);
        // console.log(JSON.stringify(this.oddsLisDis));
        // this.oddsLisDis = this.oddsLisDisNew;
        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  setOdds(item: any) {

    Object.keys(item).forEach((key: any) => {
      if (item[key].runners) {
        let temp = Object.assign({}, ...item[key].runners.map((elt: any) => ({ [elt.selectionId]: elt })));
        item[key]['cRunners'] = temp;
      }
      if (item[key].book_maker_odds) {
        let temp = Object.assign({}, ...item[key].book_maker_odds.map((elt: any) => ({ [elt.selection_id]: elt })));
        item[key]['cRunners'] = temp;
      }
    });

    this.oddsLisDis = item;
    this.betSlipData['oddsLisDis'] = item;

  }


  public exposLisDis: any = {};
  // getExposure(req: any) {
  //   this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
  //     (res) => {
  //       if (res.status == true) {
  //         res = res.data.exposes;
  //         res = this.setExposeData(res);
  //         this.isLoad = false;
  //       }
  //     },
  //     (err) => {
  //       console.log(err);
  //     });
  // }

  // setExposeData(res: any) {
  //   if (res != null) {
  //     res.forEach((element: any) => {
  //       if (element && element != null) {
  //         Object.keys(element).forEach(el => {
  //           if (el != 'market_id' && el != 'event_id') {
  //             element[el] = parseFloat(element[el]).toFixed(2);
  //           }
  //         });
  //         this.exposLisDis[element?.marketId ? element?.marketId : element?.market_id] = element;
  //         //console.log(this.exposLisDis);
  //       }
  //     });
  //   }
  // }


  getExposure(req: any, items: any) {
      this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
          (res) => {
              if (res.status == true) {
                  res = res.data.exposes;
                  res = this.string_to_JSON(res);
                  items = this.setExposeData(items, res);
                  this.data = items;
                  this.isLoad = false;
              }
          },
          (err) => {
              console.log(err);
          });
  }

  tempExpo: any[] = [];
  setExposeData(items: any, res: any) {
      if (items && res) {
          // average expose
          res.forEach((element: any) => {
              element.forEach((expo: any, i: any) => {
                  this.tempExpo.forEach((tEle: any) => {
                      if (tEle && tEle?.market_id == expo?.market_id && tEle[`${expo?.selection_id}_expose`]) {
                          if (tEle?.market_id[0] == '9') {
                              expo.expose = Number(tEle[`${expo?.selection_id}_expose`]);
                          } else {
                              expo.expose += Number(tEle[`${expo?.selection_id}_expose`]);
                          }
                      }
                  });
              });
          });
          res.forEach((element: any) => {
              element.forEach((expo: any, i: any) => {
                  if (element.length == 2) {
                      if (i == 0) {
                          let avg_value: any;
                          avg_value = Math.abs((parseFloat(element[0].expose) / parseFloat(element[1].expose))).toFixed(2);
                          if (!isFinite(avg_value)) {
                              element[i]["average"] = '';
                          } else {
                              element[i]["average"] = ' (' + avg_value + ')';
                          }
                      } else {
                          let avg_value: any;
                          avg_value = Math.abs((parseFloat(element[1].expose) / parseFloat(element[0].expose))).toFixed(2);
                          if (!isFinite(avg_value)) {
                              element[i]["average"] = '';
                          } else {
                              element[i]["average"] = ' (' + avg_value + ')';
                          }
                      }
                  }
              });
          });
          res.forEach((element: any) => {
              let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
              this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = temp;
          });
      }
      return items;
  }

  openModal(template: TemplateRef<any>, key: any) {
    let cls = (key == 'book') ? 'modal-dialog bookModal' : (key == 'rule') ? 'modal-dialog modal-dialog-scrollable rulesModaldetail' : ''
    let id = (key == 'bets') ? 'MobileStakes' : ''
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: cls }, { id: id })
    );
  }

  fancyRunPosition(template: TemplateRef<any>, item: any) {
    if (this.exposLisDis[item?.market_id] && this.exposLisDis[item?.market_id][item?.selection_id + '_expose']) {
      this.openModal(template, 'book');
      let tempReq = { "market_id": item.market_id }
      let req = this._common.JSON_to_URLEncoded(tempReq);
      this.getServices().Post(`${this.env.baseUrl + this.api.fancyRunPosition}`, req).subscribe(
        (res) => {
          if (res.status == true) {
            let fr = Object.keys(res.data.position).map((key: any) => ({ key: Number(key), value: res.data.position[key] }))

            // if (fr[0].key > 4) {
            //   for (let i = 1; i <= 4; i++) {
            //     fr.unshift({ key: fr[0].key - 1, value: fr[0].value });
            //   }
            // }
            // for (let i = 1; i <= 4; i++) {
            //   fr.push({ key: fr[fr.length - 1].key + 1, value: fr[fr.length - 1].value });
            // }
            this.fancyRun = fr;
          }
        },
        (err) => {
          console.log(err)
        });
    }
  }

  multiMarketUpdate(item: any, key: any) {
    // console.log(item);
    let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/${item?.market_type_id}/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;

    this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (key == 'save') {
            this.multiMarketIds.push(item?.market_id)
          } else {
            // this.multiMarketIds = JSON.parse(res?.data?.multi)
            this.getData();
          }
          this._message.succmessage(res?.data?.message);
          // this.fancyRun = JSON.parse(res.data.position);
        }
      },
      (err) => {
        console.log(err)
      });
  }

  openBetPlace(e: any) {
    let data = this.betSlipData = this._common.getBetSlipData(e?.item, e?.oddsItem, e?.i, e?.bet, e?.oi, e?.bkOrLy, e?.key, this.token);
    this.betSlipData['oddsLisDis'] = this.oddsLisDis;

    if (data && data?.price) {
      data['event_name'] = this.data?.event?.event?.name;
      this.betSlipModal?.show();
    } else {
      this.betSlipData = {}
    }
  }

  closeBet(e: any) {
    this.betSlipModal?.hide();
    this.nextExpoList = {};
    this.betSlipData = {}
  }



  callGetData: boolean = false;
  updateData(e: any) {
    this.token = e;
    this.betSlipData = {};
    this.getExposure(this.marketsReq, this.data);
    this.callGetData = true;
  }

  ifTwoOdds(e: any) {
    return (e?.active_rate == 1 && e?.active_rate1 == 0 && e?.active_rate2 == 0) || (e?.active_rate == 0 && e?.active_rate1 == 1 && e?.active_rate2 == 0) || (e?.active_rate == 0 && e?.active_rate1 == 0 && e?.active_rate2 == 1)
  }

  ifFourOdds(e: any) {
    return (e?.active_rate == 0 && e?.active_rate1 == 1 && e?.active_rate2 == 1) || (e?.active_rate == 1 && e?.active_rate1 == 0 && e?.active_rate2 == 1) || (e?.active_rate == 1 && e?.active_rate1 == 1 && e?.active_rate2 == 0)
  }

  createMarketIdList(items: any) {
    // console.log(items);

    let market: any[] = [];
    items.forEach((ele: any) => {
      ele.forEach((element: any) => {
        if (element.market_id) {
          market.push('market_ids[]=' + encodeURIComponent(element?.market_id))
        }
      });
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];
    // console.log(market);

    return market.join('&');
  }

  createMarketIds(items: any) {
    let market: any[] = [];

    items.forEach((ele: any) => {
      ele.forEach((element: any) => {
        if (element.market_id) {
          market.push(element?.market_id)
        }
      });
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];
    // console.log(market);

    return market;
  }

  detailPage(e: any) {
    this.router.navigate(['event/detail', e.event_id])
  }

  changeExpo(data: any) {
    // console.log(data);

    data?.runners.forEach((element: any) => {
      if (element?.selectionId)
        this.nextExpoList[`${data?.market_id}-${element?.selectionId}`] = element.pnlNext;
      if (element?.selection_id)
        this.nextExpoList[`${data?.market_id}-${element?.selection_id}`] = element.pnlNext;

    });
    // console.log(this.nextExpoList);

  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
